import { render, staticRenderFns } from "./VideoCom.vue?vue&type=template&id=29053f92&scoped=true&"
import script from "./VideoCom.vue?vue&type=script&lang=js&"
export * from "./VideoCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29053f92",
  null
  
)

export default component.exports